import { format, set } from 'date-fns'
import { de, fr } from 'date-fns/locale'
import i18n from 'atpjs/helpers/i18n'

const dateLocale = {
  de,
  fr
}

export const DAY_PATTERN = {
  de: 'd.',
  fr: 'd'
}

export const LARGE_DATE_PATTERN = {
  de: 'd. MMM yyyy',
  fr: 'd MMM yyyy'
}

const TIME_PATTERN = {
  de: 'HH.mm',
  fr: "H'h'mm"
}

const LARGE_DATE_TIME_PATTERN = {
  de: 'EEEE, d. MMMM yyyy, HH.mm',
  fr: "EEEE d MMMM yyyy HH'h'mm"
}

export const formatDateTime = (date, locale = i18n.locale) => {
  return format(date, `dd.MM.yyyy ${TIME_PATTERN[locale]}`)
}

export const formatTime = (date, locale = i18n.locale) => {
  return format(date, TIME_PATTERN[locale])
}

export const formatDate = (date) => {
  return format(date, 'yyyy-MM-dd') + 'T00:00:00.000Z'
}

export const dayWithDateTime = (date, locale = i18n.locale) => {
  return format(date, LARGE_DATE_TIME_PATTERN[locale], {
    locale: dateLocale[locale]
  })
}

export const parseTimeString = (time = '00:00') => {
  const [hours, minutes] = time.split(':').map(Number)
  return formatTime(set(new Date(), { hours, minutes, seconds: 0, milliseconds: 0 }))
}
